export default __webpack_public_path__ + "static/media/hn.d313240b.svg";